import { WjMenu } from '@grapecity/wijmo.angular2.input';
import { Injectable } from '@angular/core';
import { FlexSheetService } from './flex-sheet.service';
import { DiagnosticReportService } from '@features/global-tax-calculator/services/diagnostic-report.service';
import { FlexSheetNavigationService } from './flex-sheet-navigation.service';
import { FlexSheetCellMenuService } from './flex-sheet-cell-menu.service';
import { FlexSheetCellTemplateCreateService } from './flex-sheet-cell-template-create.service';

@Injectable({
  providedIn: 'root'
})
export class FlexSheetCellClickService {

  constructor(
    private flexSheetService: FlexSheetService,
    private flexSheetNavigationService: FlexSheetNavigationService,
    private diagnosticReportService: DiagnosticReportService,
    private flexSheetCellMenuService: FlexSheetCellMenuService,
    private flexSheetCellTemplateCreateService: FlexSheetCellTemplateCreateService,

  ) { }

  onCellClick(e: MouseEvent) {
    const flexSheet = this.flexSheetService.getFlexSheet();
    let hti = flexSheet.hitTest(e);
    if (hti.panel === flexSheet.cells) {
      let row = flexSheet.rows[hti.row], col = flexSheet.columns[hti.col];
      let dataItem = row.dataItem;
      let currentCellData = flexSheet.getCellValue(row.index, col.index, false);
      this.flexSheetNavigationService.setActiveCell(row.index, col.index);
      this.diagnosticReportService.showDiagnosticReportCellRecordMismatchedHistoryOnRightSidebarForWorkbook(this.flexSheetService.getCurrentWorkBook().id, this.flexSheetService.getCurrentWorkSheet().id, this.flexSheetService.getCurrentWorkSheet().name, row.index, col.index);
    }
  }


  onContextMenu(event: MouseEvent, flexSheetCtxMenu: WjMenu) {
    const selectedCellRange = this.flexSheetService.getFlexSheet().selectedRanges;

    this.flexSheetNavigationService.setActiveCell(selectedCellRange[0].row, selectedCellRange[0].col);
    const cellModel = this.flexSheetService.getCellModel(selectedCellRange[0].row2, selectedCellRange[0].col2);
    var isValidOverwriteCellRange =  this.flexSheetService.isOverwriteByCellRangeOrStyle(selectedCellRange)

    if (isValidOverwriteCellRange) {
      const magicLinkModel = this.flexSheetService.getMagicLinkModel();
      const scenarioId = magicLinkModel?.fieldValues?.['ScenarioId'];
      const scenarioType = magicLinkModel?.fieldValues?.['ScenarioType'];
      const formId = magicLinkModel?.fieldValues?.['FormId'];
      this.flexSheetCellTemplateCreateService.configureOverwriteCells(
        cellModel,
        this.flexSheetService.getFlexSheet(),
        this.flexSheetService.getApi(),
        this.flexSheetService.getCurrentWorkBookSetId(),
        this.flexSheetService.getCurrentWorkBook().id,
        this.flexSheetService.getCurrentWorkSheet().id,
        true,
        async () => {
          await this.flexSheetService.refreshSelectedWorkSheet();
        },
        scenarioId,
        scenarioType,
        formId);
    } else {
      this.flexSheetCellMenuService.setCellMenus([{ cmd: 'Refresh', iconClass: '', label: 'refresh' }]);
      flexSheetCtxMenu.hide();
    }
  }
}
